import Telemetry from './Telemetry';
import { PageVisibilityObserver } from './utils/observers';
export default function initTelemetry(backends) {
  const getContext = () => ({
    page: Telemetry.activePageName || 'PAGE_UNKNOWN',
    pageNavigationStart: Telemetry.pageNavigationStartTime,
    isInitialRender: Telemetry.isInitialRender,
    hasDocumentBeenHidden: PageVisibilityObserver.hasDocumentBeenHidden
  });
  Telemetry.messageQueue.setSubscriber(event => {
    backends.forEach(backend => backend(event, getContext));
  });
}